module.exports = __webpack_public_path__ + "img/cartoon-one-box.8294657c.png";